<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <help-text>
          <h3>
            Portals
          </h3>

          <p>
            This list displays the portals that the company is relevant for.
          </p>

          <p>
            If the path field is filled out, the company is published on the portal.
          </p>

          <router-link
              :to="'/companies/'+company.data.id+'/portals/create'"
              class="btn btn-sm btn-black"
          >
            <i class="fa fa-plus"></i> Add Portal
          </router-link>
        </help-text>
      </div>

      <div class="col-xs-18">
        <PortalCompanyList :company="company.data"/>
      </div>
    </div>
  </div>
</template>

<script>
import HelpText from '@/components/HelpText'
import PortalCompanyList from "../../../../../components/PortalCompanies/Panels/List";

export default {
  components: {PortalCompanyList, HelpText},

  model: {
    prop: 'company',
    event: 'company-updated'
  },

  props: ['company']
}
</script>
